<template>
    <div 
    id="modal-action-roles"
    class="absolute top-0 left-0 w-full h-full z-60 bg-black/10 rounded-lg flex items-start justify-center p-10">
        <div class="w-full max-w-sm h-auto bg-white border rounded-lg  p-4">
            <h1>{{ $t(titleKey) }} {{ $t("settings.auto.registro") }}</h1>

            <form 
            class="flex flex-col gap-4 mt-4" 
            @submit.prevent="submit()">
                <div class="w-full flex flex-col gap-2">
                    <label 
                    for="name" 
                    class="text-sm">{{ $t("settings.auto.nombre_del_rol") }}</label>
                    <input 
                    type="text" 
                    name="name" 
                    id="name" 
                    class="w-full p-2 border rounded-lg" 
                    v-model="roleForm.name"/>
                </div>

                <div class="w-full flex flex-col gap-2">
                    <label 
                    for="permissions"
                    class="text-sm">{{ $t("settings.auto.permisos") }}</label>
                    <div class="w-full grid grid-cols-2 py-1 px-4 ">
                        <div
                        v-for="permission in permissions" 
                        :key="permission.id"
                        class="flex items-center mb-4" >
                            <input 
                            type="checkbox"
                            :value="permission.id"
                            v-model="roleForm.permissions"
                            class="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-2 ">
                            <label class="ms-2 text-sm font-medium text-gray-900">{{ permission.name }}</label>
                        </div>
                    </div>
                </div>

                <div class="w-full flex justify-end gap-2">
                    <button 
                    type="button"
                    class="w-auto text-eblack-500 py-1 px-4 rounded-lg text-sm inline-flex justify-center items-center gap-2"
                    @click="closeModal()">
                        <span>{{ $t("settings.auto.cancelar") }}</span>
                    </button>
                    <button 
                    type="submit"
                    class="bg-egreen-500 w-auto text-white py-1 px-4 rounded-lg text-sm inline-flex justify-center items-center gap-2"
                    >
                        <span>
                            {{ isUpdating ? $t("settings.auto.actualizar") : $t("settings.auto.agregar") }}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name:'ActionModal',
    props:['permissions','role'],
    data(){
        return {
            titleKey:'settings.auto.nuevo',
            isUpdating:false,
            roleForm:{
                name:'',
                slug:'',
                permissions:[]
            }
        }
    },
    watch:{
        'role': {
            handler(value){
                if(value){
                    this.titleKey = 'settings.auto.actualizar';
                    this.isUpdating = true;
                    this.roleForm.name = this.role.name;
                    this.roleForm.permissions = this.role.permissions.map(permission => permission.id);
                }
            },
            immediate:true
        }
    },
    methods:{
        submit(){
            this.prepareSlug();
            if(this.isUpdating){
                this.roleForm.id = this.role.id;
                this.$emit('update',this.roleForm);
            }else{
                this.$emit('create',this.roleForm);
            }
            this.resetForm()
        },
        closeModal(){
            this.resetForm()
            this.$emit('close');
        },
        confirmAction(){
            this.$emit('confirm');
        },
        resetForm(){
            this.roleForm.name = '';
            this.roleForm.permissions = [];
        },
        prepareSlug(){
            let slug = this.roleForm.name
            .toLowerCase() 
            .normalize("NFD") 
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "_") 
            .replace(/[^\w_]+/g, ""); 
    
            this.roleForm.slug = slug;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
